<div class="keyboard-shortcuts">
   <p *ngFor="let shortcutMap of ks.shortcuts | keyvalue">
      <ng-container *ngIf="shortcutMap.value as shortcut">
         <mat-icon [svgIcon]="shortcut.svgIcon">{{shortcut.icon}}</mat-icon>
         <span>{{shortcut.description}}</span>
         <span color="primary">{{shortcut.keyDisplay}}</span>
      </ng-container>
   </p>
</div>
